
class AddOnAdjuster {
	static moveAddOns(fulfillmentDetails){
		try{
			const ac = document.querySelector('#add-on__container');
			let atc = document.querySelector('.add-ons__wrapper');
			let dualPath = document.querySelector('#dual-path__checkbox');
			// if(!dualPath){
				if(ac && atc){
					atc.appendChild(ac);
					setTimeout(()=>{
						_enableDisableInstallationAddOn(false);
					}, 1000);
				}
			// }

			if(ac){
				swapMultiAddOnLeftRight();
				restyleHDPP();
				restyleInstallations();
				restyleInHomeInstallations();
				restyleInHomeAssembly()
			}


		}catch(e){
			console.error(e);
		}
	}

	static reAdjustExpertInHome(){
		try{
			const ac = document.querySelector('#add-on__container');
			// let atc = document.querySelector('.add-ons__wrapper');
			let dualPath = document.querySelector('#dual-path__checkbox');
			const bbNew = document.querySelector('#buybelt-wrapper-new');
			if(ac && dualPath && bbNew){
				bbNew.append(ac);
				ac.style["padding-top"] = "20px";
			}
		}catch(e){
			console.error(e);
		}
	}

	static enableDisableInstallationAddOn(enabled){
		return _enableDisableInstallationAddOn(enabled);
	}
}



function swapMultiAddOnLeftRight(){
       try{
               const multi = document.querySelector('.multi-add-on__container');
               if(multi){
                       const left = document.querySelector('#multi-add-on-left');
                       const right = document.querySelector('#multi-add-on-right');
                       if(left && right){
							left.parentNode.appendChild(left);
                       }
                if(window.innerWidth < 600){
					multi.style.display = 'block';
					left.classList.remove('col-6');
					right.classList.remove('col-6');
				}
               }
       }catch(e){
               console.error(e);
       }
}

function restyleHDPP(){
	try{
		let hdpp = document.querySelector('#buyBox-hdpp');
		let atcDisabled =  document.querySelector('.bttn--atc.disabled');
		if(hdpp && !atcDisabled){
			hdpp = hdpp.querySelector('label');
			if(hdpp){
				let priceContainer = hdpp.querySelector('.buybox__add-on__price');
				let head = hdpp.querySelector('span.u__bold');
				if(priceContainer && head){
					let price = priceContainer.innerText;
					let headText = head.innerText;
					head.innerText = 'Protect This Item';
					headText = headText.replace('-yr', ' year');
					headText = headText.replace('for', ('plan / ' + price));
					priceContainer.innerText = ('\n' + headText);
					priceContainer.classList.remove('buybox__add-on__price');
				}
			}
		}else if(hdpp) {
			hdpp.classList.add('u--hide');
		}
	}catch(e){
		console.error(e);
	}
}

function restyleInstallations() {
	try {
		let proReferral = document.querySelector('#buyBox-pro-referral');
		if (proReferral) {
			proReferral = proReferral.querySelector('label');
			let head = proReferral && proReferral.querySelector('span.u__bold');
			if (head) {
				head.innerText = 'Get In-Home Installation';
				head.insertAdjacentHTML('afterend', "<span><br>Powered by Pro Referral</span>");
			}
		}
	} catch (e) {
		console.error(e);
	}
}

function restyleInHomeInstallations() {
	try{
		let inHomeInstall = document.querySelector('#buyBox-attach-labor');
		if(inHomeInstall ){
			inHomeInstall =  inHomeInstall.querySelector('label');
			let head = inHomeInstall && inHomeInstall.querySelector('span.u__bold');
			if(head) {
				head.innerText = head.innerText.replace('for', ('plan /'));
				// head.innerText = `${head.innerText}.00`;
				head.insertAdjacentHTML('beforebegin', "<span class='u__bold'>Get In-Home Installation <br></span>");
				head.classList.remove('u__bold');
			}
		}
	}catch(e){
		console.error(e);
	}
}

function restyleInHomeAssembly() {
	try{
		let inHomeAssembly = document.querySelector('#buyBox-assembly');
		let learnMore = document.querySelector('.buybox__add-on__learn-more-cta');
		if(inHomeAssembly ){
			inHomeAssembly =  inHomeAssembly.querySelector('label');
			let head = inHomeAssembly && inHomeAssembly.getElementsByTagName('span');
			if(head) {
				head[0].innerText = "Need It Assembled?";
				head[1].innerText = head[1].innerText.replace('for as low as', 'Add In-Home Assembly /');
				head[1].classList.remove('u__bold');
				learnMore.innerText = 'What to Expect?';
			}
		}
	}catch(e){
		console.error(e);
	}
}

function _enableDisableInstallationAddOn(enabled=false){
	try{
		let install = document.querySelector('#attach-labor__checkbox');
		let inHomeInstall = document.querySelector('#buyBox-attach-labor');
		if(install){
			if(enabled){
				install.removeAttribute("disabled");
				if(inHomeInstall){
					let additionalText = inHomeInstall.querySelector('.buybox__add-on__learn-more-cta');
					if(additionalText){
						additionalText.style.display = "block"
					}
				}
			}else{
				install.setAttribute("disabled", true);
				if(inHomeInstall){
					let additionalText = inHomeInstall.querySelector('.buybox__add-on__learn-more-cta');
					if(additionalText){
						additionalText.style.display = "none"
					}
				}
			}
		}else{
			if(isIe11()){
				setTimeout(()=>{
					try{
						install = document.querySelector('#attach-labor__checkbox');
						inHomeInstall = document.querySelector('#buyBox-attach-labor');
						if(install){
							if(enabled){
								install.removeAttribute("disabled");
								if(inHomeInstall){
									let additionalText = inHomeInstall.querySelector('.buybox__add-on__learn-more-cta');
									if(additionalText){
										additionalText.style.display = "block"
									}
								}
							}else{
								install.setAttribute("disabled", true);
								if(inHomeInstall){
									let additionalText = inHomeInstall.querySelector('.buybox__add-on__learn-more-cta');
									if(additionalText){
										additionalText.style.display = "none"
									}
								}
							}
						}
					}catch(e){
						console.error(e);
					}
				}, 5000)
			}
		}

		let assembly = document.querySelector('#assembly__checkbox');
		if (assembly) {
			enabled ? assembly.removeAttribute("disabled") : assembly.setAttribute("disabled", true);
		}
	}catch(e){
		console.error(e);
	}
}

function isIe11(){
	try{
	  return (!!window.MSInputMethodContext && !!document.documentMode);
	}catch(e){
	  console.error(e);
	}
}

export default AddOnAdjuster;
